import React, { Component } from 'react'
import PropTypes from 'prop-types'

import classnames from 'classnames'
import { RIEInput } from 'riek'
import TextareaAutosize from 'react-autosize-textarea'

import Switch from '../../common/switch'

import RiderSharing from '../rider-sharing/sharing'
import RiderSharingForm from '../rider-sharing/sharing-form'

class General extends Component {
  constructor(props) {
    super(props)

    this.state = {
      title: '',
      description: '',
      publicSharing: undefined,
      linkSharing: undefined,
      showDropdown: false,
      showSharingDropdown: false
    }

    this.title = React.createRef()
  }

  componentWillMount() {
    const { title, description, publicSharing, linkSharing } = this.props

    this.setState({title, description, publicSharing, linkSharing})
  }

  componentWillReceiveProps(nextProps) {
    const { title, description, publicSharing, linkSharing } = nextProps

    if (title !== this.props.title) this.setState({title})
    if (description !== this.props.description) this.setState({description})
    if (publicSharing !== this.props.publicSharing) this.setState({publicSharing})
    if (linkSharing !== this.props.linkSharing) this.setState({linkSharing})
  }

  shouldComponentUpdate(nextProps, nextState) {
    const { title, description, publicSharing, linkSharing, shares } = nextState

    if (title !== this.props.title) return true
    if (description !== this.props.description) return true
    if (publicSharing !== this.props.publicSharing) return true
    if (linkSharing !== this.props.linkSharing) return true
    if (shares !== this.props.shares) return true
    if (nextState !== this.state) return true
    return false
  }

  // getSharingStatus(sharing) { // converts string value
  //   return {
  //     'public': 'Public',
  //     'url': 'Link-only',
  //     'private': 'Private'
  //   }[sharing]
  // }

  renderDropdown() {
    const { showDropdown } = this.state

    const className = classnames({
      'ui-dropdown': true,
      'ui-dropdown--main': true,
      'ui-dropdown--active': showDropdown
    })

    return (
      <div className={className}>
        {showDropdown === true ? <div className="ui-dropdown-escape" onClick={() => this.setState({showDropdown: !showDropdown})} /> : null}

        <div className="ui-dropdown-handle" onClick={() => this.setState({showDropdown: !showDropdown})}>
          <div className="ui-dropdown-handle-ball" />
          <div className="ui-dropdown-handle-ball" />
          <div className="ui-dropdown-handle-ball" />
        </div>

        {
          showDropdown === true
          ? <ul className="ui-dropdown-content">
              <li onClick={() => this.setState({showDropdown: false}, () => this.title.current.startEditing())}>Rename rider</li>
              <li onClick={() => this.setState({showDropdown: false, showSharingDropdown: true})}>Share rider</li>
              <li onClick={() => this.setState({showDropdown: false}, () => this.props.exportPDF('rider-document'))}>Export as PDF (experimental)</li>
              <li onClick={() => this.props.deleteRider()}>Delete rider</li>
            </ul>
          : null
        }
      </div>
    )
  }

  renderSharingDropdown(publicSharing, linkSharing) {
    const { shares } = this.props
    const { showSharingDropdown } = this.state

    const className = classnames({
      'ui-dropdown': true,
      'ui-dropdown--sharing': true,
      'ui-dropdown--active': showSharingDropdown
    })

    return (
      <div className={className}>
        {showSharingDropdown === true ? <div className="ui-dropdown-escape" onClick={() => this.setState({showSharingDropdown: !showSharingDropdown})} /> : null}

        <div className="ui-dropdown-value" onClick={() => this.setState({showSharingDropdown: !showSharingDropdown})}>
          {
            publicSharing
            ? linkSharing
              ? "Public and shared with link"
              : "Public"
            : linkSharing
              ? "Shared with link"
              : "Private"
          }
        </div>

        {
          showSharingDropdown === true
          ? <ul className="ui-dropdown-content">
              <li>
                <Switch
                  required={publicSharing}
                  toggleSwitch={(required) => this.setState({showSharingDropdown: false}, () => this.props.editRider({publicSharing: !publicSharing}))} />

                <span className="title">Public</span>
                <small>Your rider can be searched by all users.</small>
              </li>
              <li>
                <Switch
                  required={linkSharing}
                  toggleSwitch={(required) => this.setState({showSharingDropdown: false}, () => this.props.editRider({linkSharing: !linkSharing}))} />

                <span className="title">Link sharing</span>
                <small>Anyone with a link can view this rider.</small>
              </li>
              <li className="hr" />
              <li>
                <small>Invite band member with write permissions:</small>
              </li>
              <li>
                <RiderSharingForm
                  shareRider={this.props.shareRider} />
              </li>
              {
                shares.length > 0
                ? <li>
                    <small>Current collaborators:</small>
                    <ol>
                      {
                        shares.map((share, index) => (
                          <li key={index} onClick={() => this.props.removeRiderShare(share.id)}>— {share.email}</li>
                        ))
                      }
                    </ol>
                  </li>
                : null
              }
            </ul>
          : null
        }
      </div>
    )
  }

  render() {
    const { view, shares } = this.props
    const { title, description, publicSharing, linkSharing } = this.state

    const titleClassName = classnames({
      'riek': true,
      'riek--focusable': view.editable,
      'title': true,
      'h1': true,
      'placeholder': !title
    })

    const descriptionClassName = classnames({
      'textarea-autosize': true,
      'textarea-autosize--focusable': view.editable,
      'description': true,
      'placeholder': !description
    })

    return (
      <section className="general">
        <div className="heading">
          {
            view.editable
            ? <RIEInput ref={this.title}
                value={title || 'Title - click to add'}
                propName="title"
                className={titleClassName}
                classEditing="riek-editing"
                change={({title}) => this.setState({title}, () => this.props.editRider({title}))} />
            : <div className={titleClassName}>{title}</div>
          }

          {
            view.editable
            ? this.renderSharingDropdown(publicSharing, linkSharing)
            : null
          }

          {/*
            view.editable
            ? <RiderSharing
                shares={shares}
                removeRiderShare={this.props.removeRiderShare} />
            : null
          */}

          {
            view.editable
            ? this.renderDropdown()
            : null
          }
        </div>

        {
          view.editable
          ? <TextareaAutosize
              value={description !== null ? description : 'Please click to add your rider description'}
              className={descriptionClassName}
              onClick={() => {
                if (description === null) {
                  this.setState({
                    description: ''
                  })
                }
              }}
              onChange={(e) => {
                this.setState({
                  description: e.target.value
                })
              }}
              onBlur={() => {
                if (description) {
                  this.props.editRider({description})
                } else {
                  this.setState({
                    description: null
                  })
                }
              }} />
          : <div className="textarea-autosize description">{description}</div>
        }

        {/*<p>This rider describes the band requirements in four parts:</p>

        <ul>
          <li><a>Band members</a></li>
          <li><a>Instruments and related equipment</a></li>
          <li><a>Other technical requirements</a></li>
          <li><a>Non-technical requirements</a></li>
        </ul>

        <h2>General</h2>*/}
      </section>
    )
  }
}

General.propTypes = {
  view: PropTypes.object,
  title: PropTypes.string,
  description: PropTypes.string,
  publicSharing: PropTypes.bool,
  linkSharing: PropTypes.bool,
  shares: PropTypes.array,
  editRider: PropTypes.func,
  shareRider: PropTypes.func,
  removeRiderShare: PropTypes.func,
  deleteRider: PropTypes.func,
  exportPDF: PropTypes.func
}

General.defaultProps = {
  view: {},
  title: '',
  description: '',
  publicSharing: undefined,
  linkSharing: undefined,
  shares: [],
  editRider: function() {},
  shareRider: function() {},
  removeRiderShare: function() {},
  deleteRider: function() {},
  exportPDF: function() {}
}

export default General



// WEBPACK FOOTER //
// ./src/components/rider/rider-general/general.js